function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ChevronRightIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M8.71457 20L16.8 12L8.71457 4L7.46665 5.44589L14.0905 12L7.46665 18.5541L8.71457 20Z",
    fill: "currentColor"
  }));
}
export function ChevronRightIconSmall(props) {
  return ___EmotionJSX(ChevronRightIcon, _extends({
    size: "small"
  }, props));
}